import * as types from "./mutation-types";

export default {
  [types.SET_QUEUE](state, payload) {
    state.queue = payload;
  },
};
